import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React, { useState } from 'react';
import { Button, Message } from 'semantic-ui-react';
import _isEmpty from 'lodash/isEmpty';
import { DEFAULT_PLACE_ORDER_BUTTON_TEXT } from './ReviewOrder.constants';
import { getOrderSubtotal } from '../../../services/checkout/order';
import { getErrorMessage } from '../../../utils/api';
import { classNames } from '../../../utils/classname';
import CartSummary from '../CartSummary';
import { CartPropType } from '../CartSummary/CartSummary.propTypes';
import CartSummaryTray from '../CartSummaryTray';
import './ReviewOrder.css';
var defaultProps = {
  onPlaceOrder: null,
  disabled: false,
  placeOrderButtonContent: DEFAULT_PLACE_ORDER_BUTTON_TEXT,
  tip: 0.0,
  onTipChange: null,
  onUpdateCartItemQuantity: function onUpdateCartItemQuantity() {
    return null;
  },
  onUpdateCartItem: function onUpdateCartItem() {
    return null;
  },
  onDeleteCartItem: function onDeleteCartItem() {
    return null;
  },
  onSpecialInstructionsChange: null,
  getOrderItemOptions: null,
  loading: false,
  asTray: false
};
function ReviewOrder(_ref) {
  var cart = _ref.cart,
    onPlaceOrder = _ref.onPlaceOrder,
    disabled = _ref.disabled,
    placeOrderButtonContent = _ref.placeOrderButtonContent,
    tip = _ref.tip,
    onTipChange = _ref.onTipChange,
    onUpdateCartItemQuantity = _ref.onUpdateCartItemQuantity,
    onUpdateCartItem = _ref.onUpdateCartItem,
    onDeleteCartItem = _ref.onDeleteCartItem,
    onSpecialInstructionsChange = _ref.onSpecialInstructionsChange,
    getOrderItemOptions = _ref.getOrderItemOptions,
    loading = _ref.loading,
    asTray = _ref.asTray;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    placingOrder = _useState2[0],
    setPlacingOrder = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMsg = _useState4[0],
    setErrorMsg = _useState4[1];
  function clearError() {
    setErrorMsg('');
  }
  function handlePlaceOrder() {
    return _handlePlaceOrder.apply(this, arguments);
  }
  function _handlePlaceOrder() {
    _handlePlaceOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setPlacingOrder(true);
            clearError();
            _context.prev = 2;
            _context.next = 5;
            return onPlaceOrder();
          case 5:
            _context.next = 10;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](2);
            setErrorMsg(getErrorMessage(_context.t0));
          case 10:
            _context.prev = 10;
            setPlacingOrder(false);
            return _context.finish(10);
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 7, 10, 13]]);
    }));
    return _handlePlaceOrder.apply(this, arguments);
  }
  if (_isEmpty(cart)) return null;
  var subTotal = getOrderSubtotal(cart);
  var orderAmountIsZero = subTotal === 0;
  var disabledPlaceOrderButton = disabled || placingOrder || loading || orderAmountIsZero;
  var CartComponent = asTray ? CartSummaryTray : CartSummary;
  return /*#__PURE__*/React.createElement(CartComponent, {
    cart: cart,
    tip: tip,
    onTipChange: onTipChange,
    displayHeaderActions: true,
    readOnly: true,
    onUpdateCartItemQuantity: onUpdateCartItemQuantity,
    onUpdateCartItem: onUpdateCartItem,
    onDeleteCartItem: onDeleteCartItem,
    getOrderItemOptions: getOrderItemOptions,
    loading: loading,
    fixedCartTotals: false,
    defaultShow: true,
    onSpecialInstructionsChange: onSpecialInstructionsChange
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames({
      'review-order-container': true,
      tray: asTray
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "place-order-button-container"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "place-order-button",
    onClick: handlePlaceOrder,
    disabled: disabledPlaceOrderButton,
    loading: loading || placingOrder,
    content: placeOrderButtonContent,
    primary: true
  })), errorMsg && /*#__PURE__*/React.createElement(Message, {
    negative: true,
    onDismiss: clearError
  }, errorMsg)));
}
ReviewOrder.defaultProps = defaultProps;
export default ReviewOrder;